import React, { Component, useState, useEffect } from "react";

import { Row, Col, Tabs } from "antd";
import { Margin } from "styled-components-spacing";
import Center from "react-center";

import CompaniesAddress from "./CompaniesAddress.js";

import companyTextOne from "../../../Imgs/CompaniesLogo/company1Text.png";
import companyTextTwo from "../../../Imgs/CompaniesLogo/company2Text.png";
import companyTextThree from "../../../Imgs/CompaniesLogo/company3.png";
import companyTextFour from "../../../Imgs/CompaniesLogo/company4Text.png";
import companyTextFive from "../../../Imgs/CompaniesLogo/company5Text.png";
import companyTextSix from "../../../Imgs/CompaniesLogo/company6Text.png";
import companyTextSeven from "../../../Imgs/CompaniesLogo/company7Text.png";
import companyTextEight from "../../../Imgs/CompaniesLogo/company8Text.png";
import companyTextNine from "../../../Imgs/CompaniesLogo/company9Text.png";
import companyTextTen from "../../../Imgs/CompaniesLogo/company10.svg";
import companyTextEleven from "../../../Imgs/CompaniesLogo/company11Text.png";
import companyTextTwelve from "../../../Imgs/CompaniesLogo/company12Text.png";

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/ContactUs/Contact/ContactUs.css";

const { TabPane } = Tabs;

function callback(key) {
  console.log(key);
}
const ImgTab = (props) => {
  return (
    <Center>
      <img style={{ width: "75px" }} src={props.image} />
    </Center>
  );
};

const CompaniesTabs = (props) => {
  const [change, setChange] = useState("1");

  const companyLogo = {
    width: "100%",
  };
  const companyLogo1 = {
    width: "100%",
    filter: "grayscale(0)",
  };
  return props.size === "laptopdesktop" ? (
    <div>
      <Center>
        <Margin top={5}>
          <div>
            <p className="subTitle">
              <strong>آدرس شرکت های ما</strong>
            </p>
          </div>
        </Margin>
      </Center>
      <Center>
        <div className="subTitleHR"></div>
      </Center>
      <Margin top={3}></Margin>
      <Row className="tabs clearfix" data-tabgroup="first-tab-group">
        <Col span={3}></Col>
        <Col span={18}>
          <Row>
            <Col span={2}>
              <a href="#tab12" class="grayEffect">
                <Center>
                  <div>
                    <div>
                      <figure>
                        <img
                          name="12"
                          onClick={(e) => setChange(e.target.name)}
                          style={change == "12" ? companyLogo1 : companyLogo}
                          src={companyTextTwelve}
                        />
                      </figure>
                    </div>
                  </div>
                </Center>
              </a>
            </Col>
            <Col span={2}>
              <a href="#tab11" class="grayEffect">
                <Center>
                  <div>
                    <div>
                      <figure>
                        <img
                          name="11"
                          onClick={(e) => setChange(e.target.name)}
                          style={change == "11" ? companyLogo1 : companyLogo}
                          src={companyTextEleven}
                        />
                      </figure>
                    </div>
                  </div>
                </Center>
              </a>
            </Col>
            <Col span={2}>
              <a href="#tab10" class="grayEffect">
                <Center>
                  <div>
                    <div>
                      <figure>
                        <img
                          name="10"
                          onClick={(e) => setChange(e.target.name)}
                          style={change == "10" ? companyLogo1 : companyLogo}
                          src={companyTextTen}
                        />
                      </figure>
                    </div>
                  </div>
                </Center>
              </a>
            </Col>
            <Col span={2}>
              <a href="#tab9" class="grayEffect">
                <Center>
                  <div>
                    <div>
                      <figure>
                        <img
                          name="9"
                          onClick={(e) => setChange(e.target.name)}
                          style={change == "9" ? companyLogo1 : companyLogo}
                          src={companyTextNine}
                        />
                      </figure>
                    </div>
                  </div>
                </Center>
              </a>
            </Col>
            <Col span={2}>
              <a href="#tab8" class="grayEffect">
                <Center>
                  <div>
                    <div>
                      <figure>
                        <img
                          name="8"
                          onClick={(e) => setChange(e.target.name)}
                          style={change == "8" ? companyLogo1 : companyLogo}
                          src={companyTextEight}
                        />
                      </figure>
                    </div>
                  </div>
                </Center>
              </a>
            </Col>
            <Col span={2}>
              <a href="#tab7" class="grayEffect">
                <Center>
                  <div>
                    <div>
                      <figure>
                        <img
                          name="7"
                          onClick={(e) => setChange(e.target.name)}
                          style={change == "7" ? companyLogo1 : companyLogo}
                          src={companyTextSeven}
                        />
                      </figure>
                    </div>
                  </div>
                </Center>
              </a>
            </Col>
            <Col span={2}>
              <a href="#tab6" class="grayEffect">
                <Center>
                  <div>
                    <div>
                      <figure>
                        <img
                          name="6"
                          onClick={(e) => setChange(e.target.name)}
                          style={change == "6" ? companyLogo1 : companyLogo}
                          src={companyTextSix}
                        />
                      </figure>
                    </div>
                  </div>
                </Center>
              </a>
            </Col>
            <Col span={2}>
              <a href="#tab5" class="grayEffect">
                <Center>
                  <div>
                    <div>
                      <figure>
                        <img
                          name="5"
                          onClick={(e) => setChange(e.target.name)}
                          style={change == "5" ? companyLogo1 : companyLogo}
                          src={companyTextFive}
                        />
                      </figure>
                    </div>
                  </div>
                </Center>
              </a>
            </Col>
            <Col span={2}>
              <a href="#tab4" class="grayEffect">
                <Center>
                  <div>
                    <div>
                      <figure>
                        <img
                          name="4"
                          onClick={(e) => setChange(e.target.name)}
                          style={change == "4" ? companyLogo1 : companyLogo}
                          src={companyTextFour}
                        />
                      </figure>
                    </div>
                  </div>
                </Center>
              </a>
            </Col>
            <Col span={2}>
              <a href="#tab3" class="grayEffect">
                <Center>
                  <div>
                    <div>
                      <figure>
                        <img
                          name="3"
                          onClick={(e) => setChange(e.target.name)}
                          style={change == "3" ? companyLogo1 : companyLogo}
                          src={companyTextThree}
                        />
                      </figure>
                    </div>
                  </div>
                </Center>
              </a>
            </Col>
            <Col span={2}>
              <a href="#tab2" class="grayEffect">
                <Center>
                  <div>
                    <div>
                      <figure>
                        <img
                          name="2"
                          onClick={(e) => setChange(e.target.name)}
                          style={change == "2" ? companyLogo1 : companyLogo}
                          src={companyTextTwo}
                        />
                      </figure>
                    </div>
                  </div>
                </Center>
              </a>
            </Col>
            <Col span={2}>
              <a href="#tab1" class="grayEffect">
                <Center>
                  <div>
                    <div>
                      <figure>
                        <img
                          name="1"
                          onClick={(e) => setChange(e.target.name)}
                          style={change == "1" ? companyLogo1 : companyLogo}
                          src={companyTextOne}
                        />
                      </figure>
                    </div>
                  </div>
                </Center>
              </a>
            </Col>
          </Row>
        </Col>
        <Col span={3}></Col>
      </Row>
      <section id="first-tab-group" class="tabgroup">
        <div id="tab1">
          <Margin top={3}>
            <CompaniesAddress
              phone="۰۲۱-۸۴۲۲۸"
              fax="021-88552084-5"
              mail="info@ipinsur.ir"
              address="تهران- ولی عصر – ابتدای یوسف آباد – خیابان سید جمال الدین اسد آبادی – خیابان هفتم – پلاک ۱۴ – ساختمان ایرانیان پوشش"
              map="https://maps.google.com/maps?q=%D8%A7%D8%B1%D8%B2%DB%8C%D8%A7%D8%A8%DB%8C%20%D8%AE%D8%B3%D8%A7%D8%B1%D8%AA%20%D8%A7%DB%8C%D8%B1%D8%A7%D9%86%DB%8C%D8%A7%D9%86%20%D9%BE%D9%88%D8%B4%D8%B4&t=&z=13&ie=UTF8&iwloc=&output=embed"
              size="laptopdesktop"
            />
          </Margin>
        </div>
        <div id="tab2">
          <Margin top={3}>
            <CompaniesAddress
              phone="10 -021-84229300"
              fax="1433713131"
              mail="info@andishkadebime.ir"
              address="تهران، خیابان ولی عصر(عج)، روبروی خیابان مطهری، پلاک 2034، طبقه اول"
              map="https://maps.google.com/maps?q=35%C2%B043%2726.4%22N%2051%C2%B024%2737.3%22E&t=m&z=16&output=embed&iwloc=near"
              size="laptopdesktop"
            />
          </Margin>
        </div>
        <div id="tab3">
          <Margin top={3}>
            <CompaniesAddress
              phone="۸۴۲۲۹۶۵۰ – ۰۲۱"
              fax="۱۴۳۳۶۳۴۳۳۵"
              mail="info@moraghebbime.ir"
              address="تهران خيابان فتحي شقاقي خيابان فراهاني پور خيابان دوم پلاك دو قديم و پلاك ١٤ جديد طبقه اول و دوم پایگاه خبری مراقب بيمه"
              map="https://maps.google.com/maps?q=%D8%AE%DB%8C%D8%A7%D8%A8%D8%A7%D9%86%20%D9%81%D8%AA%D8%AD%DB%8C%20%D8%B4%D9%82%D8%A7%D9%82%DB%8C&t=&z=13&ie=UTF8&iwloc=&output=embed"
              size="laptopdesktop"
            />
          </Margin>
        </div>
        <div id="tab4">
          <Margin top={3}>
            <CompaniesAddress
              phone="۰۲۱-۸۴۲۲۸"
              fax="۵-۸۸۵۵۲۰۸۴-۰۲۱"
              mail="info@ipinsur.ir"
              address="تهران- ولی عصر – ابتدای یوسف آباد – خیابان سید جمال الدین اسد آبادی – خیابان هفتم – پلاک ۱۴ – ساختمان ایرانیان پوشش"
              map="https://maps.google.com/maps?q=%D8%A7%D8%B1%D8%B2%DB%8C%D8%A7%D8%A8%DB%8C%20%D8%AE%D8%B3%D8%A7%D8%B1%D8%AA%20%D8%A7%DB%8C%D8%B1%D8%A7%D9%86%DB%8C%D8%A7%D9%86%20%D9%BE%D9%88%D8%B4%D8%B4&t=&z=13&ie=UTF8&iwloc=&output=embed"
              size="laptopdesktop"
            />
          </Margin>
        </div>
        <div id="tab5">
          <Margin top={3}>
            <CompaniesAddress
              phone="021-84229601-5"
              fax="۸۹۷۸۵۱۵۴"
              mail="contactus@dadgarbime.ir"
              address="تهران، یوسف آباد، خ ابن سینا، نبش خیابان نهم، پلاک 6"
              map="https://maps.google.com/maps?q=35.725629%2C%2051.410937&t=m&z=16&output=embed&iwloc=near"
              size="laptopdesktop"
            />
          </Margin>
        </div>
        <div id="tab6">
          <Margin top={3}>
            <CompaniesAddress
              phone="021-88556172"
              fax="021-89785154"
              mail="info@hamiarbime.ir"
              address="تهران، خیابان سیدجمال الدین اسد آبادی ، خ نهم ، نبش خ ابن سینا ، پلاک 6 ، ط 4"
              map="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3239.0377998727054!2d51.405792414854595!3d35.72528888018401!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3f8e013799c19b4d%3A0x5cff6604cf72d0f9!2sAsad+Abadi+St+%26+9th+St%2C+District+6%2C+Tehran%2C+Tehran+Province%2C+Iran!5e0!3m2!1sen!2s!4v1557571845305!5m2!1sen!2s"
              size="laptopdesktop"
            />
          </Margin>
        </div>
        <div id="tab7">
          <Margin top={3}>
            <CompaniesAddress
              phone="021-84229980-5"
              fax=""
              mail="contact@kankashbimeh.ir"
              address="تهران - دانشگاه شهید بهشتی - مرکز رشد واحدهای فناوری و کارآفرینی"
              map="https://maps.google.com/maps?q=%D8%AA%D9%87%D8%B1%D8%A7%D9%86%20%20%D8%AF%D8%A7%D9%86%D8%B4%DA%AF%D8%A7%D9%87%20%D8%B4%D9%87%DB%8C%D8%AF%20%D8%A8%D9%87%D8%B4%D8%AA%DB%8C%20%20%D9%85%D8%B1%DA%A9%D8%B2%20%D8%B1%D8%B4%D8%AF%20%D9%88%D8%A7%D8%AD%D8%AF%D9%87%D8%A7%DB%8C%20%D9%81%D9%86%D8%A7%D9%88%D8%B1%DB%8C%20%D9%88%20%DA%A9%D8%A7%D8%B1%D8%A2%D9%81%D8%B1%DB%8C%D9%86%DB%8C&t=&z=13&ie=UTF8&iwloc=&output=embed"
              size="laptopdesktop"
            />
          </Margin>
        </div>
        <div id="tab8">
          <Margin top={3}>
            <CompaniesAddress
              phone="021-88552997"
              fax="۸۹۷۸۵۱۵۴"
              mail="contactus@dadrasbime.ir"
              address="تهران ، یوسف آباد ، خیابان ابن سینا، نبش خیابان نهم ، پلاک 6"
              map="https://maps.google.com/maps?q=35.725629%2C%2051.410937&t=m&z=16&output=embed&iwloc=near"
              size="laptopdesktop"
            />
          </Margin>
        </div>
        <div id="tab9">
          <Margin top={3}>
            <CompaniesAddress
              phone="۰۲۱-۸۴۲۲۸"
              fax="021-88552084-5"
              mail="info@ipinsur.ir"
              address="تهران- ولی عصر – ابتدای یوسف آباد – خیابان سید جمال الدین اسد آبادی – خیابان هفتم – پلاک ۱۴ – ساختمان ایرانیان پوشش"
              map="https://maps.google.com/maps?q=%D8%A7%D8%B1%D8%B2%DB%8C%D8%A7%D8%A8%DB%8C%20%D8%AE%D8%B3%D8%A7%D8%B1%D8%AA%20%D8%A7%DB%8C%D8%B1%D8%A7%D9%86%DB%8C%D8%A7%D9%86%20%D9%BE%D9%88%D8%B4%D8%B4&t=&z=13&ie=UTF8&iwloc=&output=embed"
              size="laptopdesktop"
            />
          </Margin>
        </div>
        <div id="tab10">
          <Margin top={3}>
            <CompaniesAddress
              phone="۰۲۱-۸۴۲۲۸"
              fax="021-88552084-5"
              mail="info@ipinsur.ir"
              address="تهران- ولی عصر – ابتدای یوسف آباد – خیابان سید جمال الدین اسد آبادی – خیابان هفتم – پلاک ۱۴ – ساختمان ایرانیان پوشش"
              map="https://maps.google.com/maps?q=%D8%A7%D8%B1%D8%B2%DB%8C%D8%A7%D8%A8%DB%8C%20%D8%AE%D8%B3%D8%A7%D8%B1%D8%AA%20%D8%A7%DB%8C%D8%B1%D8%A7%D9%86%DB%8C%D8%A7%D9%86%20%D9%BE%D9%88%D8%B4%D8%B4&t=&z=13&ie=UTF8&iwloc=&output=embed"
              size="laptopdesktop"
            />
          </Margin>
        </div>
        <div id="tab11">
          <Margin top={3}>
            <CompaniesAddress
              phone="021-66177594"
              fax=""
              mail="info@aminpooshesh.com"
              address="تهران – خ ولی عصر – نرسیده به سه راه جمهوری – پ 1050"
              map="https://maps.google.com/maps?q=35.6951677%2C51.403872&t=m&z=15&output=embed&iwloc=near"
              size="laptopdesktop"
            />
          </Margin>
        </div>
        <div id="tab12">
          <Margin top={3}>
            <CompaniesAddress
              phone="۰۴۴-۳۱۳۶"
              fax=""
              mail="zhiyar97@yahoo.com"
              address=""
              map=""
              size="laptopdesktop"
            />
          </Margin>
        </div>
      </section>
    </div>
  ) : props.size === "tablet" ? (
    <div>
      <Center>
        <Margin top={5}>
          <div>
            <p className="subTitleTablet">
              <strong>آدرس شرکت های ما</strong>
            </p>
          </div>
        </Margin>
      </Center>
      <Center>
        <hr className="subTitleHRTablet" />
      </Center>
      <Margin top={3}></Margin>
      <Row className="tabs clearfix" data-tabgroup="first-tab-group">
        <Col span={1}></Col>
        <Col span={22}>
          <Row>
            <Col span={2}>
              <a href="#tab12Tablet" class="grayEffect">
                <Center>
                  <div>
                    <div>
                      <figure>
                        <img
                          name="12"
                          onClick={(e) => setChange(e.target.name)}
                          style={change == "12" ? companyLogo1 : companyLogo}
                          src={companyTextTwelve}
                        />
                      </figure>
                    </div>
                  </div>
                </Center>
              </a>
            </Col>
            <Col span={2}>
              <a href="#tab11Tablet" class="grayEffect">
                <Center>
                  <div>
                    <div>
                      <figure>
                        <img
                          name="11"
                          onClick={(e) => setChange(e.target.name)}
                          style={change == "11" ? companyLogo1 : companyLogo}
                          src={companyTextEleven}
                        />
                      </figure>
                    </div>
                  </div>
                </Center>
              </a>
            </Col>
            <Col span={2}>
              <a href="#tab10Tablet" class="grayEffect">
                <Center>
                  <div>
                    <div>
                      <figure>
                        <img
                          name="10"
                          onClick={(e) => setChange(e.target.name)}
                          style={change == "10" ? companyLogo1 : companyLogo}
                          src={companyTextTen}
                        />
                      </figure>
                    </div>
                  </div>
                </Center>
              </a>
            </Col>
            <Col span={2}>
              <a href="#tab9Tablet" class="grayEffect">
                <Center>
                  <div>
                    <div>
                      <figure>
                        <img
                          name="9"
                          onClick={(e) => setChange(e.target.name)}
                          style={change == "9" ? companyLogo1 : companyLogo}
                          src={companyTextNine}
                        />
                      </figure>
                    </div>
                  </div>
                </Center>
              </a>
            </Col>
            <Col span={2}>
              <a href="#tab8Tablet" class="grayEffect">
                <Center>
                  <div>
                    <div>
                      <figure>
                        <img
                          name="8"
                          onClick={(e) => setChange(e.target.name)}
                          style={change == "8" ? companyLogo1 : companyLogo}
                          src={companyTextEight}
                        />
                      </figure>
                    </div>
                  </div>
                </Center>
              </a>
            </Col>
            <Col span={2}>
              <a href="#tab7Tablet" class="grayEffect">
                <Center>
                  <div>
                    <div>
                      <figure>
                        <img
                          name="7"
                          onClick={(e) => setChange(e.target.name)}
                          style={change == "7" ? companyLogo1 : companyLogo}
                          src={companyTextSeven}
                        />
                      </figure>
                    </div>
                  </div>
                </Center>
              </a>
            </Col>
            <Col span={2}>
              <a href="#tab6Tablet" class="grayEffect">
                <Center>
                  <div>
                    <div>
                      <figure>
                        <img
                          name="6"
                          onClick={(e) => setChange(e.target.name)}
                          style={change == "6" ? companyLogo1 : companyLogo}
                          src={companyTextSix}
                        />
                      </figure>
                    </div>
                  </div>
                </Center>
              </a>
            </Col>
            <Col span={2}>
              <a href="#tab5Tablet" class="grayEffect">
                <Center>
                  <div>
                    <div>
                      <figure>
                        <img
                          name="5"
                          onClick={(e) => setChange(e.target.name)}
                          style={change == "5" ? companyLogo1 : companyLogo}
                          src={companyTextFive}
                        />
                      </figure>
                    </div>
                  </div>
                </Center>
              </a>
            </Col>
            <Col span={2}>
              <a href="#tab4Tablet" class="grayEffect">
                <Center>
                  <div>
                    <div>
                      <figure>
                        <img
                          name="4"
                          onClick={(e) => setChange(e.target.name)}
                          style={change == "4" ? companyLogo1 : companyLogo}
                          src={companyTextFour}
                        />
                      </figure>
                    </div>
                  </div>
                </Center>
              </a>
            </Col>
            <Col span={2}>
              <a href="#tab3Tablet" class="grayEffect">
                <Center>
                  <div>
                    <div>
                      <figure>
                        <img
                          name="3"
                          onClick={(e) => setChange(e.target.name)}
                          style={change == "3" ? companyLogo1 : companyLogo}
                          src={companyTextThree}
                        />
                      </figure>
                    </div>
                  </div>
                </Center>
              </a>
            </Col>
            <Col span={2}>
              <a href="#tab2Tablet" class="grayEffect">
                <Center>
                  <div>
                    <div>
                      <figure>
                        <img
                          name="2"
                          onClick={(e) => setChange(e.target.name)}
                          style={change == "2" ? companyLogo1 : companyLogo}
                          src={companyTextTwo}
                        />
                      </figure>
                    </div>
                  </div>
                </Center>
              </a>
            </Col>
            <Col span={2}>
              <a href="#tab1Tablet" class="grayEffect">
                <Center>
                  <div>
                    <div>
                      <figure>
                        <img
                          name="1"
                          onClick={(e) => setChange(e.target.name)}
                          style={change == "1" ? companyLogo1 : companyLogo}
                          src={companyTextOne}
                        />
                      </figure>
                    </div>
                  </div>
                </Center>
              </a>
            </Col>
          </Row>
        </Col>
        <Col span={1}></Col>
      </Row>
      <section id="first-tab-group" class="tabgroup">
        <div id="tab1Tablet">
          <Margin top={3}>
            <CompaniesAddress
              phone="۰۲۱-۸۴۲۲۸"
              fax="021-88552084-5"
              mail="info@ipinsur.ir"
              address="تهران- ولی عصر – ابتدای یوسف آباد – خیابان سید جمال الدین اسد آبادی – خیابان هفتم – پلاک ۱۴ – ساختمان ایرانیان پوشش"
              map="https://maps.google.com/maps?q=%D8%A7%D8%B1%D8%B2%DB%8C%D8%A7%D8%A8%D8%A7%D9%86%20%D8%A7%DB%8C%D8%B1%D8%A7%D9%86%DB%8C%D8%A7%D9%86%20%D9%BE%D9%88%D8%B4%D8%B4&t=&z=13&ie=UTF8&iwloc=&output=embed"
              size="tablet"
            />
          </Margin>
        </div>
        <div id="tab2Tablet">
          <Margin top={3}>
            <CompaniesAddress
              phone="10 -021-84229300"
              fax="1433713131"
              mail="info@andishkadebime.ir"
              address="تهران، خیابان ولی عصر(عج)، روبروی خیابان مطهری، پلاک 2034، طبقه اول"
              map="https://maps.google.com/maps?q=35%C2%B043%2726.4%22N%2051%C2%B024%2737.3%22E&t=m&z=16&output=embed&iwloc=near"
              size="tablet"
            />
          </Margin>
        </div>
        <div id="tab3Tablet">
          <Margin top={3}>
            <CompaniesAddress
              phone="۸۴۲۲۹۶۵۰ – ۰۲۱"
              fax="۱۴۳۳۶۳۴۳۳۵"
              mail="info@moraghebbime.ir"
              address="تهران خيابان فتحي شقاقي خيابان فراهاني پور خيابان دوم پلاك دو قديم و پلاك ١٤ جديد طبقه اول و دوم پایگاه خبری مراقب بيمه"
              map="https://maps.google.com/maps?q=%D8%AE%DB%8C%D8%A7%D8%A8%D8%A7%D9%86%20%D9%81%D8%AA%D8%AD%DB%8C%20%D8%B4%D9%82%D8%A7%D9%82%DB%8C&t=&z=13&ie=UTF8&iwloc=&output=embed"
              size="tablet"
            />
          </Margin>
        </div>
        <div id="tab4Tablet">
          <Margin top={3}>
            <CompaniesAddress
              phone="۰۲۱-۸۴۲۲۸"
              fax="۵-۸۸۵۵۲۰۸۴-۰۲۱"
              mail="info@ipinsur.ir"
              address="تهران- ولی عصر – ابتدای یوسف آباد – خیابان سید جمال الدین اسد آبادی – خیابان هفتم – پلاک ۱۴ – ساختمان ایرانیان پوشش"
              map="https://maps.google.com/maps?q=%D8%A7%D8%B1%D8%B2%DB%8C%D8%A7%D8%A8%DB%8C%20%D8%AE%D8%B3%D8%A7%D8%B1%D8%AA%20%D8%A7%DB%8C%D8%B1%D8%A7%D9%86%DB%8C%D8%A7%D9%86%20%D9%BE%D9%88%D8%B4%D8%B4&t=&z=13&ie=UTF8&iwloc=&output=embed"
              size="tablet"
            />
          </Margin>
        </div>
        <div id="tab5Tablet">
          <Margin top={3}>
            <CompaniesAddress
              phone="021-84229601-5"
              fax="۸۹۷۸۵۱۵۴"
              mail="contactus@dadgarbime.ir"
              address="تهران، یوسف آباد، خ ابن سینا، نبش خیابان نهم، پلاک 6"
              map="https://maps.google.com/maps?q=35.725629%2C%2051.410937&t=m&z=16&output=embed&iwloc=near"
              size="tablet"
            />
          </Margin>
        </div>
        <div id="tab6Tablet">
          <Margin top={3}>
            <CompaniesAddress
              phone="021-88556172"
              fax="021-89785154"
              mail="info@hamiarbime.ir"
              address="تهران، خیابان سیدجمال الدین اسد آبادی ، خ نهم ، نبش خ ابن سینا ، پلاک 6 ، ط 4"
              map="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3239.0377998727054!2d51.405792414854595!3d35.72528888018401!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3f8e013799c19b4d%3A0x5cff6604cf72d0f9!2sAsad+Abadi+St+%26+9th+St%2C+District+6%2C+Tehran%2C+Tehran+Province%2C+Iran!5e0!3m2!1sen!2s!4v1557571845305!5m2!1sen!2s"
              size="tablet"
            />
          </Margin>
        </div>
        <div id="tab7Tablet">
          <Margin top={3}>
            <CompaniesAddress
              phone="021-84229980-5"
              fax=""
              mail="contact@kankashbimeh.ir"
              address="تهران - دانشگاه شهید بهشتی - مرکز رشد واحدهای فناوری و کارآفرینی"
              map="https://maps.google.com/maps?q=%D8%AA%D9%87%D8%B1%D8%A7%D9%86%20%20%D8%AF%D8%A7%D9%86%D8%B4%DA%AF%D8%A7%D9%87%20%D8%B4%D9%87%DB%8C%D8%AF%20%D8%A8%D9%87%D8%B4%D8%AA%DB%8C%20%20%D9%85%D8%B1%DA%A9%D8%B2%20%D8%B1%D8%B4%D8%AF%20%D9%88%D8%A7%D8%AD%D8%AF%D9%87%D8%A7%DB%8C%20%D9%81%D9%86%D8%A7%D9%88%D8%B1%DB%8C%20%D9%88%20%DA%A9%D8%A7%D8%B1%D8%A2%D9%81%D8%B1%DB%8C%D9%86%DB%8C&t=&z=13&ie=UTF8&iwloc=&output=embed"
              size="tablet"
            />
          </Margin>
        </div>
        <div id="tab8Tablet">
          <Margin top={3}>
            <CompaniesAddress
              phone="021-88552997"
              fax="۸۹۷۸۵۱۵۴"
              mail="contactus@dadrasbime.ir"
              address="تهران ، یوسف آباد ، خیابان ابن سینا، نبش خیابان نهم ، پلاک 6"
              map="https://maps.google.com/maps?q=35.725629%2C%2051.410937&t=m&z=16&output=embed&iwloc=near"
              size="tablet"
            />
          </Margin>
        </div>
        <div id="tab9Tablet">
          <Margin top={3}>
            <CompaniesAddress
              phone="۰۲۱-۸۴۲۲۸"
              fax="021-88552084-5"
              mail="info@ipinsur.ir"
              address="تهران- ولی عصر – ابتدای یوسف آباد – خیابان سید جمال الدین اسد آبادی – خیابان هفتم – پلاک ۱۴ – ساختمان ایرانیان پوشش"
              map="https://maps.google.com/maps?q=%D8%A7%D8%B1%D8%B2%DB%8C%D8%A7%D8%A8%DB%8C%20%D8%AE%D8%B3%D8%A7%D8%B1%D8%AA%20%D8%A7%DB%8C%D8%B1%D8%A7%D9%86%DB%8C%D8%A7%D9%86%20%D9%BE%D9%88%D8%B4%D8%B4&t=&z=13&ie=UTF8&iwloc=&output=embed"
              size="tablet"
            />
          </Margin>
        </div>
        <div id="tab10Tablet">
          <Margin top={3}>
            <CompaniesAddress
              phone="۰۲۱-۸۴۲۲۸"
              fax="021-88552084-5"
              mail="info@ipinsur.ir"
              address="تهران- ولی عصر – ابتدای یوسف آباد – خیابان سید جمال الدین اسد آبادی – خیابان هفتم – پلاک ۱۴ – ساختمان ایرانیان پوشش"
              map="https://maps.google.com/maps?q=%D8%A7%D8%B1%D8%B2%DB%8C%D8%A7%D8%A8%DB%8C%20%D8%AE%D8%B3%D8%A7%D8%B1%D8%AA%20%D8%A7%DB%8C%D8%B1%D8%A7%D9%86%DB%8C%D8%A7%D9%86%20%D9%BE%D9%88%D8%B4%D8%B4&t=&z=13&ie=UTF8&iwloc=&output=embed"
              size="tablet"
            />
          </Margin>
        </div>
        <div id="tab11Tablet">
          <Margin top={3}>
            <CompaniesAddress
              phone="021-66177594"
              fax=""
              mail="info@aminpooshesh.com"
              address="تهران – خ ولی عصر – نرسیده به سه راه جمهوری – پ 1050"
              map="https://maps.google.com/maps?q=35.6951677%2C51.403872&t=m&z=15&output=embed&iwloc=near"
              size="tablet"
            />
          </Margin>
        </div>
        <div id="tab12Tablet">
          <Margin top={3}>
            <CompaniesAddress
              phone="۰۴۴-۳۱۳۶"
              fax=""
              mail="zhiyar97@yahoo.com"
              address=""
              map=""
              size="tablet"
            />
          </Margin>
        </div>
      </section>
    </div>
  ) : (
    <div>
      <Center>
        <Margin top={4}>
          <div>
            <p className="subTitleMobile">
              <strong>آدرس شرکت های ما</strong>
            </p>
          </div>
        </Margin>
      </Center>
      <Center>
        <hr className="subTitleHRMobile" style={{ marginTop: "-10px" }} />
      </Center>
      <div style={{ backgroundColor: "#f9f9f9" }}>
        <Margin top={3}></Margin>
        <Tabs
          defaultActiveKey="1"
          onChange={callback}
          centered
          style={{ fontFamily: "IranSans", textAlign: "center" }}
        >
          <TabPane tab={<ImgTab image={companyTextOne} />} key="1">
            <CompaniesAddress
              phone="۰۲۱-۸۴۲۲۸"
              fax="021-88552084-5"
              mail="info@ipinsur.ir"
              address="تهران- ولی عصر – ابتدای یوسف آباد – خیابان سید جمال الدین اسد آبادی – خیابان هفتم – پلاک ۱۴ – ساختمان ایرانیان پوشش"
              map="https://maps.google.com/maps?q=%D8%A7%D8%B1%D8%B2%DB%8C%D8%A7%D8%A8%D8%A7%D9%86%20%D8%A7%DB%8C%D8%B1%D8%A7%D9%86%DB%8C%D8%A7%D9%86%20%D9%BE%D9%88%D8%B4%D8%B4&t=&z=13&ie=UTF8&iwloc=&output=embed"
            />
          </TabPane>
          <TabPane tab={<ImgTab image={companyTextTwo} />} key="2">
            <CompaniesAddress
              phone="10 -021-84229300"
              fax="1433713131"
              mail="info@andishkadebime.ir"
              address="تهران، خیابان ولی عصر(عج)، روبروی خیابان مطهری، پلاک 2034، طبقه اول"
              map="https://maps.google.com/maps?q=35%C2%B043%2726.4%22N%2051%C2%B024%2737.3%22E&t=m&z=16&output=embed&iwloc=near"
            />
          </TabPane>
          <TabPane tab={<ImgTab image={companyTextFour} />} key="3">
            <CompaniesAddress
              phone="۸۴۲۲۹۶۵۰ – ۰۲۱"
              fax="۱۴۳۳۶۳۴۳۳۵"
              mail="info@moraghebbime.ir"
              address="تهران خيابان فتحي شقاقي خيابان فراهاني پور خيابان دوم پلاك دو قديم و پلاك ١٤ جديد طبقه اول و دوم پایگاه خبری مراقب بيمه"
              map="https://maps.google.com/maps?q=%D8%AE%DB%8C%D8%A7%D8%A8%D8%A7%D9%86%20%D9%81%D8%AA%D8%AD%DB%8C%20%D8%B4%D9%82%D8%A7%D9%82%DB%8C&t=&z=13&ie=UTF8&iwloc=&output=embed"
            />
          </TabPane>
          <TabPane tab={<ImgTab image={companyTextFour} />} key="4">
            <CompaniesAddress
              phone="۰۲۱-۸۴۲۲۸"
              fax="۵-۸۸۵۵۲۰۸۴-۰۲۱"
              mail="info@ipinsur.ir"
              address="تهران- ولی عصر – ابتدای یوسف آباد – خیابان سید جمال الدین اسد آبادی – خیابان هفتم – پلاک ۱۴ – ساختمان ایرانیان پوشش"
              map="https://maps.google.com/maps?q=%D8%A7%D8%B1%D8%B2%DB%8C%D8%A7%D8%A8%DB%8C%20%D8%AE%D8%B3%D8%A7%D8%B1%D8%AA%20%D8%A7%DB%8C%D8%B1%D8%A7%D9%86%DB%8C%D8%A7%D9%86%20%D9%BE%D9%88%D8%B4%D8%B4&t=&z=13&ie=UTF8&iwloc=&output=embed"
            />
          </TabPane>
          <TabPane tab={<ImgTab image={companyTextFive} />} key="5">
            <CompaniesAddress
              phone="021-84229601-5"
              fax="۸۹۷۸۵۱۵۴"
              mail="contactus@dadgarbime.ir"
              address="تهران، یوسف آباد، خ ابن سینا، نبش خیابان نهم، پلاک 6"
              map="https://maps.google.com/maps?q=35.725629%2C%2051.410937&t=m&z=16&output=embed&iwloc=near"
            />
          </TabPane>
          <TabPane tab={<ImgTab image={companyTextSix} />} key="6">
            <CompaniesAddress
              phone="021-88556172"
              fax="021-89785154"
              mail="info@hamiarbime.ir"
              address="تهران، خیابان سیدجمال الدین اسد آبادی ، خ نهم ، نبش خ ابن سینا ، پلاک 6 ، ط 4"
              map="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3239.0377998727054!2d51.405792414854595!3d35.72528888018401!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3f8e013799c19b4d%3A0x5cff6604cf72d0f9!2sAsad+Abadi+St+%26+9th+St%2C+District+6%2C+Tehran%2C+Tehran+Province%2C+Iran!5e0!3m2!1sen!2s!4v1557571845305!5m2!1sen!2s"
            />
          </TabPane>
          <TabPane tab={<ImgTab image={companyTextSeven} />} key="7">
            <CompaniesAddress
              phone="021-84229980-5"
              fax=""
              mail="contact@kankashbimeh.ir"
              address="تهران - دانشگاه شهید بهشتی - مرکز رشد واحدهای فناوری و کارآفرینی"
              map="https://maps.google.com/maps?q=%D8%AA%D9%87%D8%B1%D8%A7%D9%86%20%20%D8%AF%D8%A7%D9%86%D8%B4%DA%AF%D8%A7%D9%87%20%D8%B4%D9%87%DB%8C%D8%AF%20%D8%A8%D9%87%D8%B4%D8%AA%DB%8C%20%20%D9%85%D8%B1%DA%A9%D8%B2%20%D8%B1%D8%B4%D8%AF%20%D9%88%D8%A7%D8%AD%D8%AF%D9%87%D8%A7%DB%8C%20%D9%81%D9%86%D8%A7%D9%88%D8%B1%DB%8C%20%D9%88%20%DA%A9%D8%A7%D8%B1%D8%A2%D9%81%D8%B1%DB%8C%D9%86%DB%8C&t=&z=13&ie=UTF8&iwloc=&output=embed"
            />
          </TabPane>
          <TabPane tab={<ImgTab image={companyTextEight} />} key="8">
            <CompaniesAddress
              phone="021-88552997"
              fax="۸۹۷۸۵۱۵۴"
              mail="contactus@dadrasbime.ir"
              address="تهران ، یوسف آباد ، خیابان ابن سینا، نبش خیابان نهم ، پلاک 6"
              map="https://maps.google.com/maps?q=35.725629%2C%2051.410937&t=m&z=16&output=embed&iwloc=near"
            />
          </TabPane>
          <TabPane tab={<ImgTab image={companyTextNine} />} key="9">
            <CompaniesAddress
              phone="۰۲۱-۸۴۲۲۸"
              fax="021-88552084-5"
              mail="info@ipinsur.ir"
              address="تهران- ولی عصر – ابتدای یوسف آباد – خیابان سید جمال الدین اسد آبادی – خیابان هفتم – پلاک ۱۴ – ساختمان ایرانیان پوشش"
              map="https://maps.google.com/maps?q=%D8%A7%D8%B1%D8%B2%DB%8C%D8%A7%D8%A8%DB%8C%20%D8%AE%D8%B3%D8%A7%D8%B1%D8%AA%20%D8%A7%DB%8C%D8%B1%D8%A7%D9%86%DB%8C%D8%A7%D9%86%20%D9%BE%D9%88%D8%B4%D8%B4&t=&z=13&ie=UTF8&iwloc=&output=embed"
            />
          </TabPane>
          <TabPane tab={<ImgTab image={companyTextTen} />} key="10">
            <CompaniesAddress
              phone="۰۲۱-۸۴۲۲۸"
              fax="021-88552084-5"
              mail="info@ipinsur.ir"
              address="تهران- ولی عصر – ابتدای یوسف آباد – خیابان سید جمال الدین اسد آبادی – خیابان هفتم – پلاک ۱۴ – ساختمان ایرانیان پوشش"
              map="https://maps.google.com/maps?q=%D8%A7%D8%B1%D8%B2%DB%8C%D8%A7%D8%A8%DB%8C%20%D8%AE%D8%B3%D8%A7%D8%B1%D8%AA%20%D8%A7%DB%8C%D8%B1%D8%A7%D9%86%DB%8C%D8%A7%D9%86%20%D9%BE%D9%88%D8%B4%D8%B4&t=&z=13&ie=UTF8&iwloc=&output=embed"
            />
          </TabPane>
          <TabPane tab={<ImgTab image={companyTextEleven} />} key="11">
            <CompaniesAddress
              phone="021-66177594"
              fax=""
              mail="info@aminpooshesh.com"
              address="تهران – خ ولی عصر – نرسیده به سه راه جمهوری – پ 1050"
              map="https://maps.google.com/maps?q=35.6951677%2C51.403872&t=m&z=15&output=embed&iwloc=near"
            />
          </TabPane>
          <TabPane tab={<ImgTab image={companyTextTwelve} />} key="12">
            <CompaniesAddress
              phone="۰۴۴-۳۱۳۶"
              fax=""
              mail="zhiyar97@yahoo.com"
              address=""
              map=""
            />
          </TabPane>
        </Tabs>
      </div>
    </div>
  );
};

export default CompaniesTabs;
